import {
  useMutation,
  useQueryClient,
  UseMutationOptions,
} from '@tanstack/react-query';

import { deleteProjectMember } from '@/features/projects/shared/api/delete-project-member';
import { getProjectMemberInvitesQueryKey } from '@/features/projects/shared/hooks/use-project-member-invites-query';
import { getProjectMembersQueryKey } from '@/features/projects/shared/hooks/use-project-members-query';

interface DeleteProjectMemberInput {
  projectId: number;
  orgMemberId: string;
}

type Props = Omit<
  UseMutationOptions<void, unknown, DeleteProjectMemberInput>,
  'mutationFn'
>;

export const useDeleteProjectMemberMutation = ({ ...props }: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...props,
    mutationFn: deleteProjectMember,
    onSuccess: async (data, variables, onMutateResult, context) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: getProjectMembersQueryKey(variables.projectId.toString()),
        }),
        queryClient.invalidateQueries({
          queryKey: getProjectMemberInvitesQueryKey(
            variables.projectId.toString(),
          ),
        }),
      ]);
      props.onSuccess?.(data, variables, onMutateResult, context);
    },
  });
};
